export const WEEK = {
  0: "monday",
  1: "tuesday",
  2: "wednesday",
  3: "thursday",
  4: "friday",
  5: "saturday",
  6: "sunday",
};

export const PRIORITY = {
  3: "Low",
  2: "Medium",
  1: "High",
  0: "Required",
};

export const MOVEMENTS = {
  "on_foot": "On foot",
  "motorcycle": "Motorcycle",
  "bike/scooter": "Bike or scooter",
  "automobile": "Automobile",
  "public_transport": "Public transport",
};

export const PRIORITY_OPT = [
  { value: 3, label: "Low" },
  { value: 2, label: "Medium" },
  { value: 1, label: "High" },
  { value: 0, label: "Required" },
];

export const COMPONENTS_OPT = [
  { value: "boolean", label: "boolean" },
  { value: "photo", label: "photo" },
  { value: "text", label: "text" },
];

export const MOVEMENTS_OPT = [
  { value: "on_foot", label: "On foot" },
  { value: "motorcycle", label: "Motorcycle" },
  { value: "bike/scooter", label: "Bike or scooter" },
  { value: "automobile", label: "Automobile" },
  { value: "public_transport", label: "Public transport" },
];

export const STATES_OPT = [
  { value: true, label: "Active" },
  { value: false, label: "Not Active" },
];

export const NKA_OPT = [
  { value: "direct", label: "NKA Direct" },
  { value: "indirect", label: "NKA Indirect" },
];

export const PM_COMPONENTS_OPT = [
  { value: "photo", label: "photo" },
  { value: "price", label: "price" },
  { value: "sale_price", label: "sale_price" },
  { value: "comment", label: "comment" },
];

export const OUTFORZ_STATUS_OPT = [
  { value: "created", label: "created" },
  { value: "ready_for_neural_network", label: "ready_for_neural_network" },
  { value: "in_neural_network", label: "in_neural_network" },
  { value: "got_an_error_in_neural_network", label: "got_an_error_in_neural_network" },
  { value: "open", label: "open" },
  { value: "in_progress", label: "in_progress" },
  { value: "review", label: "review" },
  { value: "done", label: "done" },
  { value: "closed", label: "closed" },
];

export const translatedComponents = {
  boolean: "так/ні",
  photo: "фото",
  text: "текст",
};
